import { StreamerUser } from './StreamerUser'
import { BroadcastingMethod } from './Media'

export interface StreamerInfo {
  streamer: StreamerUser
  isFollowed: boolean
  isFollowing: boolean
  currentStatus?: CurrentStatus
}

export interface CurrentStatus {
  connectStatus: ConnectStatus
  lastConnectTime: string
  offlineSeconds: number
  live?: StreamerLive
}

export const ConnectStatus = {
  offline: 0, // オフライン
  online: 1, // オンライン
  broadcast: 2, // 配信中
  viewing: 3, // 視聴中
} as const
export type ConnectStatus = typeof ConnectStatus[keyof typeof ConnectStatus]

export interface StreamerLive {
  vliveId: string
  mediaId: number
  isCollabGuest: boolean
  broadcastingMethod: BroadcastingMethod
}
